import { useTranslationRankmi } from '../../../../../../../helpers/translations.helper'
import { prefixTranslation } from '../common'

export const useTranslationExternalExternalCourses = () =>
  useTranslationRankmi({
    prefix: prefixTranslation,
  })

export * from './filtersColumns'
